
import { DataTable, DataTableRowEditCompleteEvent } from "primereact/datatable";
import { useEffect, useState } from "react";
import { RouteCodeModel } from "../../models/orders/order-list-model";
import { useTranslation } from "react-i18next";
import { Column } from "primereact/column";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import routeCodeServices from "../../services/route-codes/routecode.service";
import { AssignCode, RouteCodeUser1 } from "../../models/route-code/routecode-model";

interface DataTableProps {
  routeCodes: RouteCodeModel[];
  data: any[];
  onPageChange: (event: { first: number; rows: number }) => void;
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  filterParams: any;
  onUpdate: (data: RouteCodeUser1[]) => void;
}

const RouteCodeDataTable: React.FC<DataTableProps> = (props) => {
  const { t } = useTranslation();
  const [userData, setUserData] = useState<RouteCodeUser1[]>([]);

  useEffect(() => {
    setUserData(props.data);
  }, [props.data]);


  const onRowEditComplete = async (e: DataTableRowEditCompleteEvent) => {
  const { newData, index } = e;
  const _data = [...userData];

  const selectedRouteCodeID = Number(newData.routeCodeID || 0);
  const userAddressID = newData.userAddressID;

  if (!userAddressID) {
    console.error("Error: userAddressID is missing!");
    return;
  }

  const rowIndex = _data.findIndex((x) => x.userAddressID === userAddressID);

  if (rowIndex === -1) {
    console.error("Error: Row not found for userAddressID", userAddressID);
    return;
  }

  const oldRouteCodeID = _data[rowIndex].routeCodeID;

  if (oldRouteCodeID !== selectedRouteCodeID) {
    try {
      const putData: AssignCode = {
        userAddressID: userAddressID,
        routeCodeID: selectedRouteCodeID,
      };

      const response = await routeCodeServices.assignRouteCode1(putData);
      if (response?.isSuccess) {
        _data[rowIndex] = {
          ..._data[rowIndex],
          routeCodeID: selectedRouteCodeID,
          routeCode:
            props.routeCodes.find((rc) => rc.routeCodeID === selectedRouteCodeID)?.name ||
            "",
        };
        setUserData(_data);
         props.onUpdate(_data);
        refreshData();
      } else {
        console.error("API Update Failed", response);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  }
};

  const refreshData = async () => {
  try {
    let response;
    if (Object.keys(props.filterParams).length > 0) {
      response = await routeCodeServices.FilterAssignRouteCode({
        ...props.filterParams,
        pageNumber: props.pageNumber,
        pageSize: props.pageSize
      });
    } else {
      response = await routeCodeServices.GetAllAssignRouteCode(
        props.pageNumber,
        props.pageSize
      );
    }

    if (response) {
      setUserData(response.routeCodes);
    }
  } catch (error) {
    console.error("Error fetching updated data:", error);
  }
};

  const routeCodeEditor = (options: any) => {
    return (
      <Dropdown
        className="border-1 border-primary"
        value={options.value}
        options={props.routeCodes}
        optionLabel="name"
        optionValue="routeCodeID"
        onChange={(e: DropdownChangeEvent) => {
          options.editorCallback!(e.value); 
        }}
        style={{ textAlign: "right", width: "8em" }}
        placeholder="Choose"
      />
    );
  };

  return (
    <div className="col-12">
      <div className="card border-noround p-2">
        <DataTable
          value={userData}
          dataKey="userAddressID"
          editMode="row"
          onRowEditComplete={onRowEditComplete}
          paginator
          rows={props.pageSize}
          first={(props.pageNumber - 1) * props.pageSize}
          totalRecords={props.totalRecords}
          lazy={true}
          onPage={props.onPageChange}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate={`{first} to {last} of ${props.totalRecords}`}
          stripedRows
        >
          <Column field="mobile" header={t("assignRouteCode_mobileno")} />
          <Column field="userName" header={t("assignRouteCode_userName")} />
          <Column field="address" header={t("assignRouteCode_address")} />
          <Column field="area" header={t("assignRouteCode_area")} />
          <Column field="subDistrict" header={t("assignRouteCode_subdistrict")} />
          <Column field="district" header={t("assignRouteCode_district")} />
          <Column field="state" header={t("assignRouteCode_state")} />

          <Column
            field="routeCodeID"
            header={t("assignRouteCode_routecode")}
            editor={(options) => routeCodeEditor(options)}
            body={(rowData) =>
              props.routeCodes.find((rc) => rc.routeCodeID === rowData.routeCodeID)
                ?.name
            }
            style={{ textAlign: "right", width: "8em" }}
          />

          <Column
            header={t("assignRouteCode_action")}
            rowEditor
            headerStyle={{ minWidth: "6rem", textAlign: "right" }}
            bodyStyle={{ textAlign: "left" }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default RouteCodeDataTable;
